import {TextField} from '@mui/material';
import {ChangeEvent} from 'react';
type Props = {
  setTaskDescription: (select: string) => void;
};
const DescriptionBox = ({setTaskDescription}: Props) => {
  const handleDescription = (event: ChangeEvent<HTMLInputElement>) => {
    setTaskDescription(event.target.value);
  };
  return (
    <TextField
      sx={{'&.MuiInputBase-root': {borderRadius: '10px'}}}
      id='task-description'
      placeholder='Task Description'
      multiline
      fullWidth
      onChange={handleDescription}
      rows={4}
    />
  );
};

export default DescriptionBox;
